<template>
  <!-- 注意：此页面为老系统直接复制过来：保持原有功能 -->
  <div class="device-manage">
    <p class="tit">设备管理</p>
    <div class="menu-wrapper">
      <div class="left-group">
        <span class="room-count">设备（{{ totalCount }}）</span>
        <a-select
          default-value="设备绑定：全部"
          option-label-prop="label"
          @change="changeBindingDevice"
          :dropdownStyle="{ textAlign: 'center' }"
        >
          <a-select-option value="-1" label="设备绑定：全部">
            全部
          </a-select-option>
          <a-select-option value="1" label="设备绑定：已绑定">
            已绑定
          </a-select-option>
          <a-select-option value="0" label="设备绑定：未绑定">
            未绑定
          </a-select-option>
        </a-select>
        <a-select
          default-value="全部"
          option-label-prop="label"
          @change="changeDeviceStatus"
          :dropdownStyle="{ textAlign: 'center' }"
        >
          <p slot="title">ddd</p>
          <a-select-option value="-1" label="设备状态：全部">
            全部
          </a-select-option>
          <a-select-option value="0" label="设备状态：未接入">
            未接入
          </a-select-option>
          <a-select-option value="1" label="设备状态：在线">
            在线
          </a-select-option>
          <a-select-option value="2" label="设备状态：离线">
            离线
          </a-select-option>
        </a-select>
      </div>
      <div class="right-group">
        <a-input
          v-model="searchValue"
          placeholder="搜索设备编号、名称"
          @pressEnter="serachEvent"
        >
          <a-icon slot="prefix" type="search" />
        </a-input>
        <span @click="addDeviceModel = true" class="add-btn ZHIHUISHU_QZMD"
          >新增设备</span
        >
      </div>
    </div>
    <div v-if="isNoData" class="no-data">
      <img
        src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202110/5f162ac59c9449f1b18a1812d6cd1564.png"
        width="254"
        height="254"
      />
      <span class="no-data-tit">暂无设备管理</span>
    </div>
    <div class="table-data" v-else>
      <a-table
        @change="tableChangeEvent"
        :columns="columns"
        :data-source="deviceData"
        :pagination="{ pageSize: 20, total: totalCount }"
        :row-key="(record, index) => index"
        :loading="loading"
      >
        <a slot="num" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 20
        }}</a>
        <span slot="action" slot-scope="text, record">
          <a-tooltip placement="bottom" overlayClassName="actionTooltipClass">
            <div class="action-tooltip" slot="title">
              <span
                class="ZHIHUISHU_QZMD"
                @click="openDeviceDetailModel(record)"
                >查看详情</span
              >
              <span
                @click="openDeviceDeleteModel(record)"
                class="delete ZHIHUISHU_QZMD"
                >删除</span
              >
            </div>
            <div class="action-btn">
              <img
                class="action-icon"
                src="../../assets/img/more@2x.png"
                width="4"
                height="15"
              />
            </div>
          </a-tooltip>
        </span>
        <span slot="bindingStatus" slot-scope="text">
          {{ text ? '已绑定' : '未绑定' }}
        </span>
        <span slot="deviceStatus" slot-scope="text">
          {{
            text === 0
              ? '未接入'
              : text === 1
              ? '在线'
              : text === 2
              ? '离线'
              : ''
          }}
        </span>
        <span slot="channelMainStreamId" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              {{ text ? text : '- -' }}
            </template>
            {{ text ? text : '- -' }}
          </a-tooltip>
        </span>
        <span slot="channelSubStreamId" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              {{ text ? text : '- -' }}
            </template>
            {{ text ? text : '- -' }}
          </a-tooltip>
        </span>
      </a-table>
    </div>

    <a-modal
      wrapClassName="customModal bindDeviceClass addDeviceClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="addDeviceModel"
      @ok="handleBindDevice"
    >
      <template slot="title">
        <p class="tit">新增设备</p>
        <div class="header-group">
          <img
            class="ZHIHUISHU_QZMD"
            @click="
              addDeviceModel = false
              selectSchool = schoolList[0].schoolId
            "
            src="../../assets/img/close@2x.png"
            width="26"
            height="26"
          />
        </div>
      </template>
      <div class="device-info">
        <p class="tit">
          学校<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          :value="selectSchool"
          @change="handleSchoolChange"
          style="margin-bottom: 30px; width: 100%"
          showSearch
          optionFilterProp="children"
        >
          <a-select-option
            v-for="(item, index) in schoolList"
            :key="item.id"
            :value="item.schoolId"
          >
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
        <p class="tit">
          设备名称<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-input
          v-model="addDeviceParams.deviceName"
          placeholder="例如：北大第一教学楼5楼508教室"
        />

        <p class="tit">
          机位类型<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          v-model="addDeviceParams.deviceType"
          default-value="老师"
          style="width: 260px; margin-bottom: 30px"
        >
          <a-select-option :value="1"> 老师 </a-select-option>
          <a-select-option :value="2"> 学生 </a-select-option>
        </a-select>

        <p class="tit">
          设备通道配置<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          v-model="addDeviceParams.channelType"
          style="width: 260px; margin-bottom: 15px"
        >
          <a-select-option
            :value="item.value"
            v-for="item in channelTypeOptions"
            :key="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div>
          <p class="tit">高安全模式</p>
          <a-switch v-model="highModel" />
        </div>
        <div v-show="highModel">
          <p class="ip-tips">注意：使用高安全模式必须填写【IP地址】</p>
          <div class="two_items">
            <div>
              <p class="tit">相机类型</p>
              <div class="camera-type">
                <a-form-item>
                  <a-select
                    v-model="addDeviceParams.selectDevice"
                    style="width: 260px; margin-bottom: 15px"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  >
                    <a-select-option
                      v-for="item in deviceTypeList"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.deviceFactoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>
            <div>
              <p class="tit">
                IP地址
                <span
                  v-show="addDeviceParams.selectDevice != 0"
                  style="color: #e02020"
                  >*</span
                >
              </p>
              <a-input
                v-model="addDeviceParams.ip"
                placeholder="例如：192.168.50.47"
                style="width: 260px"
                @change="getRTSPUrlThrottleByAdd"
              />
            </div>
          </div>
          <div class="two_items">
            <div>
              <p class="tit">登录名</p>
              <a-input
                v-model="addDeviceParams.userName"
                placeholder="例如：admin"
                style="width: 260px"
                @change="getRTSPUrlThrottleByAdd"
              />
            </div>
            <div>
              <p class="tit">密码</p>
              <a-input
                v-model="addDeviceParams.userPassword"
                placeholder="例如：able1234"
                style="width: 260px"
                @change="getRTSPUrlThrottleByAdd"
              />
            </div>
          </div>
          <div class="two_items">
            <div>
              <p class="tit">球机操控用户</p>
              <a-input
                v-model="addDeviceParams.controllerUsername"
                placeholder="例如：admin"
                style="width: 260px"
              />
            </div>
            <div>
              <p class="tit">球机操控密码</p>
              <a-input
                v-model="addDeviceParams.controllerPassword"
                placeholder="例如：able1234"
                style="width: 260px"
              />
            </div>
          </div>
          <p class="tit">RTSP端口</p>
          <a-input
            v-model="addDeviceParams.port"
            placeholder="例如：554"
            style="width: 260px"
            @change="getRTSPUrlThrottleByAdd"
          />
          <p v-show="addDeviceParams.selectDevice != 0" class="tit">RTSP地址</p>
          <div style="display: flex" v-show="addDeviceParams.selectDevice != 0">
            <a-input
              v-model="addDeviceParams.rtspForBrand"
              :disabled="true"
              style="margin-bottom: 0px; width: 85%"
              placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
            />
            <a-button
              @click="doCopy"
              style="margin-left: 10px; border-radius: 16px; margin-top: 4px"
              >复制</a-button
            >
          </div>
          <p class="ip-tips" v-show="addDeviceParams.selectDevice != 0">
            建议使用Vlc、Potplayer等支持RTSP的播放器，测试生成地址能否正常播放！
          </p>
          <p v-show="addDeviceParams.selectDevice == 0" class="tit">
            <span style="color: #e02020">*</span>RTSP地址
          </p>
          <a-input
            v-model="addDeviceParams.rtsp"
            v-show="addDeviceParams.selectDevice == 0"
            placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
          />
        </div>
      </div>
      <template slot="footer">
        <span
          @click="
            addDeviceModel = false
            selectSchool = schoolList[0].schoolId
          "
          class="btn ZHIHUISHU_QZMD"
          >取消</span
        >
        <span @click="addDevice" class="btn confirm ZHIHUISHU_QZMD">确定</span>
      </template>
    </a-modal>

    <a-modal
      wrapClassName="customModal bindDeviceClass deviceDetailClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="deviceDetailModel"
      @ok="handleBindDevice"
    >
      <template slot="title">
        <p class="tit">设备详情</p>
        <div class="header-group">
          <img
            class="ZHIHUISHU_QZMD"
            @click="
              deviceDetailModel = false
              selectSchoolEdit = ''
            "
            src="../../assets/img/close@2x.png"
            width="26"
            height="26"
          />
        </div>
      </template>
      <div class="device-info">
        <p class="tit">
          设备名称<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-input
          v-model="currentDeviceData.deviceName"
          placeholder="设备名称"
        />
        <p class="tit">
          学校<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          :value="selectSchoolEdit"
          @change="handleSchoolEditChange"
          style="margin-bottom: 30px; width: 100%"
          showSearch
          optionFilterProp="children"
        >
          <a-select-option
            v-for="(item, index) in schoolList"
            :key="item.id"
            :value="item.schoolId"
          >
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
        <p class="tit">
          机位类型<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          v-model="currentDeviceData.deviceType"
          default-value="老师"
          style="width: 260px; margin-bottom: 30px"
        >
          <a-select-option :value="1"> 老师 </a-select-option>
          <a-select-option :value="2"> 学生 </a-select-option>
        </a-select>
        <p class="tit">
          设备通道配置<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          v-model="addDeviceParams.channelType"
          style="width: 260px; margin-bottom: 30px"
        >
          <a-select-option
            :value="item.value"
            v-for="item in channelTypeOptions"
            :key="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <p class="tit" v-show="currentDeviceData.channelMainStreamId">视频通道主码流ID</p>
        <a-input
          v-show="currentDeviceData.channelMainStreamId"
          v-model="currentDeviceData.channelMainStreamId"
          placeholder="视频通道主码流ID"
          disabled
        />
        <p class="tit" v-show="currentDeviceData.channelSubStreamId">视频通道子码流ID</p>
        <a-input
          v-show="currentDeviceData.channelSubStreamId"
          v-model="currentDeviceData.channelSubStreamId"
          placeholder="视频通道子码流ID"
          disabled
        />
        <p class="tit" v-show="currentDeviceData.devicePassword">设备密码</p>
        <a-input
          v-show="currentDeviceData.devicePassword"
          v-model="currentDeviceData.devicePassword"
          placeholder="设备密码"
          disabled
        />
        <p class="tit" v-show="currentDeviceData.gb2818Data">data</p>
        <a-textarea
          v-show="currentDeviceData.gb2818Data"
          v-model="currentDeviceData.gb2818Data"
          placeholder="data"
          disabled
          auto-size
        />
        <div style="margin: 0 0 10px 0">
          <p class="tit">高安全模式</p>
          <a-switch v-model="highModelEdit" />
        </div>
        <div class="two_items">
          <div>
            <p class="tit">相机类型</p>
            <div class="camera-type">
              <a-form-item>
                <a-select
                  v-model="currentDeviceData.manuFacturerId"
                  style="width: 260px; margin-bottom: 15px"
                  :disabled="!highModelEdit"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in deviceTypeList"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.deviceFactoryName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div>
            <p class="tit">
              IP地址
              <span
                v-show="currentDeviceData.manuFacturerId != 0"
                style="color: #e02020"
                >*</span
              >
            </p>
            <a-input
              v-model="currentDeviceData.ipAddress"
              placeholder="例如：192.168.50.47"
              :disabled="!highModelEdit"
              style="width: 260px"
              @change="getRTSPUrlThrottleByEdit"
            />
          </div>
        </div>
        <div class="two_items">
          <div>
            <p class="tit">登录名</p>
            <a-input
              v-model="currentDeviceData.loginName"
              placeholder="例如：admin"
              :disabled="!highModelEdit"
              style="width: 260px"
              @change="getRTSPUrlThrottleByEdit"
            />
          </div>
          <div>
            <p class="tit">密码</p>
            <a-input
              v-model="currentDeviceData.passWord"
              placeholder="例如：able1234"
              :disabled="!highModelEdit"
              style="width: 260px"
              @change="getRTSPUrlThrottleByEdit"
            />
          </div>
        </div>
        <div class="two_items">
            <div>
              <p class="tit">球机操控用户</p>
              <a-input
                v-model="currentDeviceData.controllerUsername"
                placeholder="例如：admin"
                style="width: 260px"
              />
            </div>
            <div>
              <p class="tit">球机操控密码</p>
              <a-input
                v-model="currentDeviceData.controllerPassword"
                placeholder="例如：able1234"
                style="width: 260px"
              />
            </div>
        </div>
        <p class="tit">RTSP端口号</p>
        <a-input
          v-model="currentDeviceData.port"
          placeholder="例如：554"
          :disabled="!highModelEdit"
          style="width: 260px"
          @change="getRTSPUrlThrottleByEdit"
        />
        <p v-show="currentDeviceData.manuFacturerId != 0" class="tit">
          RTSP地址
        </p>
        <div
          style="display: flex"
          v-show="currentDeviceData.manuFacturerId != 0"
        >
          <a-input
            v-model="currentDeviceData.manuFacturerPathForBrand"
            :disabled="true"
            style="width: 85%"
            placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
          />
          <a-button
            @click="doCopyByEdit"
            style="margin-left: 10px; border-radius: 16px; margin-top: 4px"
            >复制</a-button
          >
        </div>
        <p class="tit" v-show="currentDeviceData.manuFacturerId == 0">
          <span style="color: #e02020">*</span>RTSP地址
        </p>
        <a-input
          v-show="currentDeviceData.manuFacturerId == 0"
          v-model="currentDeviceData.manuFacturerPath"
          placeholder="例如：rtsp://admin:admin@192.168.49.103:554/PSIA/Streaming/channels/1"
        />
        <p class="tit configBall" >
          <span>onvif球机配置</span>
          <a-button
            type="primary"
            style="margin-left: 10px; border-radius: 16px;"
            @click="rewriteConfigBtn"
            :disabled="!highModelEdit"
          >
            写入连接
          </a-button>
        </p>
        <p class="configInfo" v-if="isShowConfigInfo">
          <span class="label">1、获取球机配置信息</span>
          <span>成功</span>
        </p>
        <p class="configInfo" v-if="isShowConfigReWrite">
          <span class="label">2、重写系统配置</span>
          <span>成功</span>
        </p>
        <p class="errorInfo" v-if="isShowErrorInfo">
          {{ isShowErrorInfo ? 'onvif异常信息：' + isShowErrorInfo : '' }}
        </p>
        <p v-if="isShow" class="tit">设备ID</p>
        <a-input
          v-if="isShow"
          v-model="currentDeviceData.deviceCode"
          placeholder="设备ID"
          disabled
        />
      </div>
      <template slot="footer">
        <span
          @click="
            deviceDetailModel = false
            selectSchoolEdit = ''
            isShowConfigInfo = false
            isShowConfigReWrite = false
            isShowErrorInfo = ''
          "
          class="btn ZHIHUISHU_QZMD"
          >取消</span
        >
        <span @click="editDeviceInfo" class="btn confirm ZHIHUISHU_QZMD"
          >确定</span
        >
      </template>
    </a-modal>

    <a-modal
      wrapClassName="customModal bindDeviceClass closeLiveClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="deleteDeviceModel"
      @ok="handleBindDevice"
    >
      <div class="close-live">
        <img
          class="close-icon ZHIHUISHU_QZMD"
          @click="deleteDeviceModel = false"
          src="../../assets/img/close@2x.png"
          width="26"
          height="26"
        />
        <img src="../../assets/img/bulb@2x.png" width="90" height="90" />
        <p class="text">确定删除此设备吗？</p>
      </div>
      <template slot="footer">
        <span
          @click="deleteDeviceModel = false"
          class="btn confirm ZHIHUISHU_QZMD"
          >再想想</span
        >
        <span @click="deleteDevice" class="btn ZHIHUISHU_QZMD">删除</span>
      </template>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'num',
    key: 'num',
    scopedSlots: { customRender: 'num' },
    width: 80,
    align: 'center',
  },
  // {
  //   title: '学校',
  //   dataIndex: 'schoolName',
  //   key: 'schoolName',
  //   width: 200,
  //   align: 'center',
  // },
  {
    title: '设备编号',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    scopedSlots: { customRender: 'deviceCode' },
    width: 200,
    align: 'center',
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    key: 'deviceName',
    ellipsis: true,
    width: 120,
    align: 'center',
  },
  // {
  //   title: '视频通道主码流ID',
  //   dataIndex: 'channelMainStreamId',
  //   key: 'channelMainStreamId',
  //   scopedSlots: { customRender: 'channelMainStreamId' },
  //   ellipsis: true,
  //   width: 180,
  //   align: 'center',
  // },
  // {
  //   title: '视频通道子码流ID',
  //   dataIndex: 'channelSubStreamId',
  //   key: 'channelSubStreamId',
  //   scopedSlots: { customRender: 'channelSubStreamId' },
  //   ellipsis: true,
  //   width: 180,
  //   align: 'center',
  // },
  // {
  //   title: '设备密码',
  //   dataIndex: 'devicePassword',
  //   key: 'devicePassword',
  //   scopedSlots: { customRender: 'devicePassword' },
  //   // ellipsis: true
  //   align: 'center',
  // },
  {
    title: 'IP地址',
    dataIndex: 'ipAddress',
    key: 'ipAddress',
    scopedSlots: { customRender: 'ipAddress' },
    align: 'center',
  },
  {
    title: '登录名',
    dataIndex: 'loginName',
    key: 'loginName',
    scopedSlots: { customRender: 'loginName' },
    align: 'center',
  },
  {
    title: '绑定状态',
    dataIndex: 'bindingStatus',
    key: 'bindingStatus',
    scopedSlots: { customRender: 'bindingStatus' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '设备状态',
    dataIndex: 'deviceStatus',
    key: 'deviceStatus',
    scopedSlots: { customRender: 'deviceStatus' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    ellipsis: true,
    class: 'action',
    align: 'center',
  },
]
import { channelTypeOptions } from '../../utils/enumerate'
import _ from 'lodash'
export default {
  name: 'EquipmentManagement',
  data() {
    return {
      deviceData: [
        {
          bindingName: null,
          bindingStatus: 0,
          deviceCode: '',
          deviceName: '',
          deviceStatus: 0,
          deviceType: 1,
          id: null,
          selectDevice: '',
          rtsp: '',
        },
      ],
      columns,
      addDeviceModel: false,
      deviceDetailModel: false,
      deleteDeviceModel: false,
      checkedList: [],
      searchValue: '', //搜索内容
      bindingStatus: -1,
      deviceStatus: -1,
      page: 1,
      addDeviceParams: {
        deviceName: '',
        deviceType: 1,
        channelType: 0,
        ip: '',
        userName: '',
        userPassword: '',
        selectDevice: '',
        port: '554',
        rtsp: '',
        rtspForBrand: '',
        controllerUsername: '',
        controllerPassword: ''
      },
      currentDeviceData: {},
      isNoData: false,
      loading: false,
      totalCount: 0,
      // 通道类型 0无通道，1仅主通道 2主通道，子通道 默认为0：
      channelTypeOptions,
      schoolList: [],
      selectSchool: '',
      selectSchoolEdit: '',
      highModel: false, // 是否是高安全模式
      highModelEdit: false, // 是否是高安全模式
      deviceTypeList: [], // 球机类型及其rtsp地址
      editDeviceInfoData: {},
      manuFacturerIdEdit: 0, // 编辑临时保存的球机类型
      isShow: false,
      isShowConfigInfo: false,
      isShowConfigReWrite: false,
      isShowErrorInfo: ''
    }
  },
  created() {
    this.getDeviceManageList()
    this.getSelectSchoolList()
    this.getManuFacturerInfo()
  },
  methods: {
    doCopy() {
      this.$copyText(this.addDeviceParams.rtspForBrand || ' ').then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    },
    doCopyByEdit() {
      this.$copyText(
        this.currentDeviceData.manuFacturerPathForBrand || ' '
      ).then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    },
    getRTSPUrlThrottleByAdd: _.throttle(function () {
      let { userName, userPassword, ip, port, selectDevice } =
        this.addDeviceParams
      let id = this.addDeviceParams.selectDevice
      let device = this.deviceTypeList.find((item) => item.id == id) || {}
      let rtspAddress = device.rtspAddress || ''
      this.getRTSP({
        ipAddress: ip,
        loginName: userName,
        passWord: userPassword,
        deviceModel: Number(this.highModel),
        manuFacturerId: selectDevice,
        manuFacturerPath: rtspAddress,
        port: port,
        isAdd: true,
      })
    }, 200),
    getRTSPUrlThrottleByEdit: _.throttle(function () {
      let { ipAddress, loginName, passWord, manuFacturerId, port } =
        this.currentDeviceData
      let device =
        this.deviceTypeList.find((item) => item.id == manuFacturerId) || {}
      let rtspAddress = device.rtspAddress || ''
      this.getRTSP({
        ipAddress: ipAddress,
        loginName: loginName,
        passWord: passWord,
        deviceModel: Number(this.highModelEdit),
        manuFacturerId: manuFacturerId,
        manuFacturerPath: rtspAddress,
        port: port,
        isAdd: false,
      })
    }, 200),
    /**
     * @description: 实时获取RTSP地址
     * @param {*}
     * @return {*}
     */
    async getRTSP(options) {
      const { isAdd } = options
      let rtspUrl = await this.$http.getRtspPath(options)
      if (!(rtspUrl.code == 200 && rtspUrl.rt))
        return this.$message.warning('获取RTSP地址失败!')
      if (isAdd) {
        this.addDeviceParams.rtspForBrand = rtspUrl.rt
      } else {
        this.currentDeviceData.manuFacturerPathForBrand = rtspUrl.rt
      }
    },
    copyError(e) {
      console.log('copyError', e)
    },
    handleSchoolChange(val) {
      this.selectSchool = val
    },
    handleSchoolEditChange(val) {
      this.selectSchoolEdit = val
    },
    async getManuFacturerInfo() {
      let res = await this.$http.getManuFacturerInfo()
      if (res.code !== 200) return this.$message.error('获取设备类型列表失败!')
      this.deviceTypeList = res.rt || []
      this.addDeviceParams.selectDevice = this.deviceTypeList[1]?.id || ''
    },
    async getSelectSchoolList() {
      try {
        let res = await this.$http.getSelectSchoolList()
        if (res.code === 200 && res.rt) {
          this.schoolList = res.rt
          this.selectSchool = this.schoolList[0]?.schoolId || ''
        }
      } catch (err) {
        console.log(err)
      }
    },
    async deleteDevice() {
      try {
        let _params = {
          deviceCode: this.currentDeviceData.deviceCode,
          deviceId: this.currentDeviceData.id,
          schoolId: this.currentDeviceData.schoolId,
        }
        let res = await this.$api.deleteDevice(_params)
        if (res.code === 200) {
          this.deleteDeviceModel = false
          this.getDeviceManageList()
          this.$message.success('删除成功')
        }
      } catch (err) {
        console.log(err)
      }
    },
    openDeviceDeleteModel(record) {
      this.currentDeviceData = JSON.parse(JSON.stringify(record))
      this.deleteDeviceModel = true
    },
    openDeviceDetailModel(record) {
      // 没有类型默认第一种类型
      if (record.manuFacturerId == undefined) {
        record.manuFacturerId = 1
      }
      record.manuFacturerPathForBrand = record.manuFacturerPath
      this.manuFacturerIdEdit = record.manuFacturerId
      this.currentDeviceData = JSON.parse(JSON.stringify(record))
      this.editDeviceInfoData = {
        ipAddress: this.currentDeviceData.ipAddress,
        loginName: this.currentDeviceData.loginName,
        passWord: this.currentDeviceData.passWord,
        port: this.currentDeviceData.port,
      }
      this.selectSchoolEdit = record.schoolId
      this.highModelEdit = Boolean(record.deviceModel)
      this.deviceDetailModel = true
    },
    async rewriteConfigBtn() {
      this.isShowConfigInfo = false
      this.isShowConfigReWrite = false
      this.isShowErrorInfo = ''
      try {
        let env = await ZRTC.checkEnv()
        if(env.success) {
          try {
            // 本地已经安装启动插件
            // 创建 MCLauncher 实例  (IP地址, 80, 球机操控用户, 球机操控密码)
            let mc = new ZRTC.MCLauncher(
              this.currentDeviceData.ipAddress || '',
              this.currentDeviceData.controllerPort || 80,
              this.currentDeviceData.controllerUsername || '',
              this.currentDeviceData.controllerPassword || '',
              this.currentDeviceData.manuFacturerId || 0
            )
            try {
              // 建立 websocket 连接
              await mc.start();
            } catch(error) {
              this.isShowErrorInfo = '设备未找到'
            }
            // 获取球机配置信息
            await mc.getVideoConfigurationOption()
            this.isShowConfigInfo = true
            // 重写系统配置
            await mc.setVideoConfigurationOption({
              quality: 3,
              encoding_complexity: "Main",
              resolution: {
                width: 1280,
                height: 720
              },
              gov_length: 25,
              frame_rate: 25,
              bit_rate: 1000
            })
            this.isShowConfigReWrite = true
            // 断开连接
            await mc.destroy()
          } catch(error) {
            // 获取配置失败  error.data || error.message
            // this.isShowErrorInfo = '设备未找到'
            this.isShowErrorInfo = error.message
          }
        } else {
          // 本地未安装插件
          // 1. 下载最新的高安全插件
          await ZRTC.getPlugin(env.url, true)
          // 2. 运行最新的高安全插件
          await ZRTC.runPlugin(env)
        }
      } catch (error) {
        // this.isShowErrorInfo = '设备未找到'
      }
    },
    async editDeviceInfo() {
      try {
        let {
          deviceName,
          deviceType,
          deviceCode,
          channelType,
          ipAddress,
          loginName,
          passWord,
          manuFacturerId,
          manuFacturerPath,
          port,
          id,
          controllerUsername,
          controllerPassword
        } = this.currentDeviceData
        if (!deviceName) this.$message.warning('请填写设备名称')
        if (!this.selectSchoolEdit) this.$message.warning('请选择学校')
        if (this.highModelEdit) {
          if (manuFacturerId != 0) {
            if (!((ipAddress || '').trim() != '')) {
              this.$message.warning('使用高安全模式必须填写【IP地址】')
              return
            }
          } else {
            if ((manuFacturerPath || '').trim() == '') {
              this.$message.warning(
                '使用高安全模式其他类型球机必须填写【RTSP地址】'
              )
              return
            }
          }
        }
        let rtspUrl = ''
        let _params = {
          deviceName,
          deviceType,
          deviceCode,
          channelType,
          schoolId: this.selectSchoolEdit,
          deviceModel: Number(this.highModelEdit),
          ipAddress,
          loginName,
          passWord,
          manuFacturerPath: rtspUrl,
          manuFacturerId,
          port,
          id,
          controllerUsername,
          controllerPassword
        }
        let device =
          this.deviceTypeList.find((item) => item.id == manuFacturerId) || {}
        let rtspAddress = device.rtspAddress || ''
        if (this.highModelEdit) {
          if (manuFacturerId == 0) {
            rtspUrl = manuFacturerPath
            _params.manuFacturerPath = rtspUrl || ''
          } else {
            rtspUrl = await this.$http.getRtspPath({
              ipAddress: ipAddress,
              loginName: loginName,
              passWord: passWord,
              deviceModel: Number(this.highModelEdit),
              manuFacturerId: manuFacturerId,
              manuFacturerPath: rtspAddress,
              port: port,
            })
            if (!(rtspUrl.code == 200 && rtspUrl.rt))
              return this.$message.warning('获取RTSP地址失败!')
            _params.manuFacturerPath = rtspUrl.rt || ''
          }
        }
        let res = await this.$api.addDevice(_params)
        if (res.code !== 200) return this.$message.error(res.msg || '编辑失败')
        const  { resultStatus, resultMessage } = typeof res.rt === 'object' ? res.rt : {}
        if (resultStatus != 1) return this.$message.error(resultMessage || '编辑失败')
        this.deviceDetailModel = false
        this.getDeviceManageList()
        this.$message.success('编辑成功')
        this.isShowConfigInfo = false
        this.isShowConfigReWrite = false
        this.isShowErrorInfo = ''
      } catch (err) {
        console.log(err)
      }
    },
    async addDevice() {
      try {
        let {
          deviceName,
          userName,
          userPassword,
          ip,
          port,
          rtsp,
          selectDevice,
        } = this.addDeviceParams
        if (!deviceName) return this.$message.warning('请填写设备名称')
        const emojiReg = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([A9|AE]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E])|([\u200D])|[\uFE0F]/
        if (emojiReg.test(deviceName)) return this.$message.warning('教室名称含有表情')
        if (!this.selectSchool) this.$message.warning('请选择学校')
        if (this.highModel) {
          if (selectDevice != 0) {
            if (!((ip || '').trim() != '')) {
              this.$message.warning('使用高安全模式必须填写【IP地址】')
              return
            }
          } else {
            if ((rtsp || '').trim() == '') {
              this.$message.warning(
                '使用高安全模式其他类型球机必须填写【RTSP地址】'
              )
              return
            }
          }
        }
        let id = this.addDeviceParams.selectDevice
        let device = this.deviceTypeList.find((item) => item.id == id) || {}
        let rtspAddress = device.rtspAddress || ''
        let req = {
          ...this.addDeviceParams,
          ...{
            schoolId: this.selectSchool,
            deviceModel: Number(this.highModel),
            ipAddress: ip,
            loginName: userName,
            passWord: userPassword,
            manuFacturerId: id,
            manuFacturerPath: rtspAddress,
            port: port,
          },
        }
        delete req.ip
        delete req.userPassword
        delete req.userName
        let rtspUrl = ''
        if (this.highModel) {
          if (selectDevice == 0) {
            rtspUrl = rtsp
            req.manuFacturerPath = rtspUrl || ''
          } else {
            rtspUrl = await this.$http.getRtspPath({
              ipAddress: ip,
              loginName: userName,
              passWord: userPassword,
              deviceModel: Number(this.highModel),
              manuFacturerId: id,
              manuFacturerPath: rtspAddress,
              port: port,
            })
            if (!(rtspUrl.code == 200 && rtspUrl.rt))
              return this.$message.warning('获取RTSP地址失败!')
            req.manuFacturerPath = rtspUrl.rt || ''
          }
        }
        let res = await this.$api.addDevice(req)
        if (res.code === 200) {
          this.addDeviceModel = false
          this.getDeviceManageList()
          this.$message.success('新增成功')
          this.selectSchool = this.schoolList[0].schoolId || ''
          this.addDeviceParams = {
            deviceName: '',
            deviceType: 1,
            channelType: 0,
            userName: '',
            userPassword: '',
            ip: '',
            port: '554',
            rtsp: '',
            selectDevice: 1,
            rtspForBrand: '',
          }
          this.highModel = false
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getDeviceManageList() {
      this.loading = true
      let _params = {
        bindingStatus: this.bindingStatus, //	绑定状态 -1:全部 0:未绑定 1:已绑定
        deviceStatus: this.deviceStatus, // 设备状态 -1:全部 0:未接入 1:在线 2:离线
        key: this.searchValue,
        pageNum: this.page,
        pageSize: 20,
      }
      let res = await this.$api.getDeviceManageList(_params)
      this.loading = false
      if (res.code === 200) {
        this.deviceData = res.rt.list
        this.totalCount = res.rt.totalCount
        if (!this.searchValue) {
          this.isNoData = res.rt.list.length === 0
        }
      }
    },
    handleBindDevice() {},
    onChange(checkedValues) {
      this.checkedList.push(checkedValues)
      console.log('checked = ', checkedValues)
      console.log('value = ', this.checkedList)
    },
    tableChangeEvent(pagination) {
      this.page = pagination.current
      this.getDeviceManageList()
    },
    serachEvent() {
      this.page = 1
      this.getDeviceManageList()
    },
    changeBindingDevice(v) {
      this.bindingStatus = v
      this.page = 1
      this.getDeviceManageList()
    },
    changeDeviceStatus(v) {
      this.deviceStatus = v
      this.page = 1
      this.getDeviceManageList()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ant-select-selection--single {
  height: 40px;
}
::v-deep .ant-select-selection__rendered {
  line-height: 36px;
}

.camera-type {
  margin: 10px 0;
  button {
    margin-right: 15px;
  }
}

.two_items {
  display: flex;
  align-content: space-between;
  justify-content: center;
  > div:nth-child(2) {
    margin-left: 20px;
  }
}

.device-manage {
  min-height: 996px;
  /* min-width: 1500px; */
  text-align: left;
  background: #fff;
  padding-top: 19px;
  box-shadow: 0 0 10px #ddd;
  border-radius: 10px;

  .no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 600px;
    .no-data-tit {
      margin-top: 20px;
      font-size: 14px;
      color: #231815;
    }
    .add-btn {
      position: absolute;
      top: 35px;
      right: 40px;
      width: 114px;
      height: 32px;
      line-height: 34px;
      text-align: center;
      background: #3db166;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .tit {
    height: 25px;
    line-height: 25px;
    margin: 0 0 10px 26px;
    padding-left: 10px;
    border-left: 4px solid #3db166;
    box-sizing: content-box;
    font-size: 18px;
  }
  .menu-wrapper {
    display: flex;
    margin: 0 40px 20px;
    justify-content: space-between;
    .left-group {
      display: flex;
      align-items: center;
      .room-count {
        margin-right: 10px;
      }
      .ant-select {
        margin-right: 20px;
        width: 174px;
      }
    }
    .right-group {
      display: flex;
      align-items: center;
      .add-btn {
        flex-shrink: 0;
        width: 114px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        background: #3db166;
        border: 1px solid #3db166;
        color: #fff;
        margin-left: 20px;
      }
    }
  }
  .table-data {
    padding: 0 40px;
    .qrcode-icon {
      cursor: pointer;
    }
    ::v-deep {
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        border-bottom: 0;
      }
      .ant-table-thead > tr > th {
        background: #f6f6f6;
      }
      .ant-table-tbody {
        tr:nth-child(even) {
          background: #f4f7fa;
        }
      }
      .action {
        text-align: center;
        .action-btn {
          text-align: center;
          padding: 5px 15px;
          cursor: pointer;
        }
        .action-icon {
          cursor: pointer;
        }
      }
      .ant-table-pagination {
        float: none;
        text-align: center;
      }
    }
  }
  .qrcode-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: auto;
    background: rgba(0, 0, 0, 0.5);
  }
}
::v-deep {
  .ant-select-dropdown {
    text-align: center;
  }
  .bindDeviceClass {
    .ant-modal {
      width: 800px !important;
      height: 650px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 650px;
        .ant-modal-header {
          border-bottom: 0;
          padding: 40px 40px 17px;
          .ant-modal-title {
            display: flex;
            align-items: center;
            .tit {
              flex: 1;
              font-size: 22px;
            }
            .header-group {
              .ant-input-affix-wrapper {
                width: 212px;
              }
              img {
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
        .ant-modal-body {
          padding: 0 40px;
          .device-bind {
            margin-bottom: 20px;
            padding: 24px 20px 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 169px;
            .tit {
              margin-bottom: 23px;
              font-size: 18px;
              color: #2b2f3b;
            }
            .device-group {
              display: flex;
              flex-wrap: wrap;
              overflow-y: scroll;
              height: 90px;
              .item {
                display: flex;
                align-items: center;
                height: 34px;
                margin: 0 20px 10px 0;
                padding: 0 10px 0 20px;
                border-radius: 20px;
                border: 1px solid #d4d4d4;
                img {
                  cursor: pointer;
                }
              }
            }
          }
          .device-list {
            margin-bottom: 20px;
            padding: 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 300px;
            overflow-y: scroll;
            .tit {
              display: flex;
              margin: 0 20px 20px 30px;
              font-size: 14px;
            }
            .device-item {
              display: flex;
              margin-bottom: 30px;
              .ant-checkbox-wrapper,
              .ant-checkbox,
              .ant-checkbox-input,
              .ant-checkbox-inner {
                width: 20px;
                height: 20px;
              }
              .device-info {
                // user-select: none;
                margin-left: 10px;
                width: 100%;
                display: flex;
                .num {
                  width: 257px;
                }
                .name {
                  width: 297px;
                }
              }
            }
          }
        }
        .ant-modal-footer {
          display: flex;
          justify-content: center;
          border-top: 0;
          padding: 0;
          .btn {
            text-align: center;
            width: 88px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            border: 1px solid #d4d4d4;
            cursor: pointer;
            &.confirm {
              margin-left: 24px;
              background: #3db166;
              border: 1px solid #3db166;
              color: #fff;
            }
          }
        }
        .ant-modal-close {
        }
      }
    }
  }
  .deviceDetailClass {
    .ant-modal {
      width: 660px !important;
      height: 650px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 650px;
        .device-info {
          /* height: auto; */
          height: 500px;
          overflow-y: scroll;
          margin-bottom: 20px;
          padding: 20px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          .tit {
            height: 25px;
            margin-bottom: 10px;
            font-size: 18px;
            color: #2b2f3b;
          }
          .configBall{
            display: flex;
            align-items: center;
          }
          .configInfo{
            width: 180px;
            color: #5579FC;
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .errorInfo{
            color: #F04236;
            margin-top: 20px;
          }
          .input-flex {
            display: flex;
            justify-content: space-between;
            .ant-input {
              width: 260px;
            }
            &.last {
              margin-bottom: 20px;
              .ant-input {
                margin-bottom: 0;
              }
            }
          }
          .ant-input {
            margin-bottom: 30px;
            width: 100%;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
          }
        }
      }
    }
  }
  .addDeviceClass {
    .ant-modal {
      width: 660px !important;
      height: 650px;
      .ant-modal-content {
        height: 660px;
        .device-info {
          height: 500px;
          overflow-y: scroll;
          margin-bottom: 20px;
          padding: 20px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          .ip-tips {
            color: #f37f61;
            margin: 15px 0;
          }
          .tit {
            margin-bottom: 10px;
            font-size: 18px;
            color: #2b2f3b;
          }
          .input-flex {
            display: flex;
            justify-content: space-between;
            .ant-input {
              width: 260px;
            }
          }
          .ant-input {
            margin-bottom: 30px;
            width: 100%;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
          }
        }
      }
    }
  }
  .closeLiveClass {
    .ant-modal {
      width: 360px !important;
      height: 272px;
      padding-bottom: 0;
      .ant-modal-content {
        position: relative;
        height: 272px;
        .ant-modal-body {
          padding: 0 32px;
        }
        .close-live {
          margin-bottom: 40px;
          padding-top: 46px;
          text-align: center;
          .text {
            font-size: 16px;
            margin-top: 20px;
            color: #354052;
          }
          .close-icon {
            position: absolute;
            top: 12px;
            right: 12px;
            cursor: pointer;
          }
        }
      }
      .ant-modal-footer {
        .confirm {
          margin: 0 24px 0 0 !important;
        }
      }
    }
  }
}
</style>
